import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

export interface ConfirmationDialogData {
  icon?: {
    name: string;
    iconClass: string;
  };
  title: string;
  text: string;
  links?: Link[]; //links can be added to the text, just specify them in the 'links' array and write '{link}' in the text, where you want to add links
  submitButtonText: string;
  cancelButtonText: string;
  confirmationDialogType?: ConfirmationDialogType;
}

interface Link {
  linkText: string;
  url: string;
}

export enum ConfirmationDialogType {
  WARNING = 'warn',
  INFO = 'primary'
}

@Component({
  selector: 'app-warning-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  standalone: true,
  imports: [MatButton, MatDialogClose, NgClass, MatIcon],
})
export class ConfirmationPopupComponent {

  // HTML use
  confirmationDialogType = ConfirmationDialogType;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData, public thisDialog: MatDialogRef<ConfirmationPopupComponent>) {
  }

  /**
   * Returns the link at a specific index from the list of links.
   * @param index Index of the link in the list
   */
  getLinkAtIndex(index: number): Link {
    if (
        this.data.links &&
        this.data.links.length > 0 &&
        index < this.data.links.length
    ) {
      return this.data.links[index];
    } else {
      return null;
    }
  }

}
